import React from 'react';
import { Button } from 'react-bootstrap';
import styles from './styles.module.scss';

interface Props {
  onClick(): void;
}

const BrandButton: React.FC<Props> = ({ children, onClick }) => (
  <Button className={styles.brandButton} variant="light" onClick={onClick}>
    {children}
  </Button>
);

export default BrandButton;
